import React, { useContext, useEffect, useState } from 'react';

import * as S from './styles';
import ScreensStaticContext from 'context/ScreensStaticContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import { intialDataForm } from './initialState';
import { ScreenCampaignType } from 'types/ScreenCampaignType';
import SimpleInput from 'components/SimpleInput';
import TitleForm from 'components/TitleForm';
import { ImgSavedProps } from 'types/ImgSavedProps';
import InputImgBigger from 'components/InputImgBigger';
import CreateImgWithRedirectAndLabel from 'components/CreateImgWithRedirectAndLabel';
import { ImageInCarrosselScreens } from 'types/ImageInCarrosselScreens';
import SimpleTextArea from 'components/SimpleTextArea';
import { color } from 'styles/pallete';
import { ItemScreenStatic } from 'types/ScreensStaticsProps';
import { editStaticScreen } from 'components/FormSreenStatics/reqs';

type CampaignFormProps = {
	closeModal: () => void;
};

export default function CampaignForm({ closeModal }: CampaignFormProps) {
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setMessage, setIsOpenLoad } = useContext(LoadGeneralContext);
	const { screens, setScreens } = useContext(ScreensStaticContext);

	const [dataForm, setDataForm] = useState(intialDataForm);

	async function saveData() {
		let screenToEdit: ItemScreenStatic = { type: 'campaign', data: null };

		const newScreens = screens.map((value) => {
			if (value.type === 'campaign') {
				value.data = dataForm;
				screenToEdit = {
					...screenToEdit,
					data: dataForm,
					id: value?.id || '0'
				};
			}

			return value;
		});

		setIsOpenLoad(true);
		setMessage('Salvando dados');
		const isSuccess = await editStaticScreen(screenToEdit, handleNotify);
		setIsOpenLoad(false);

		if (isSuccess) {
			setScreens(newScreens);
			closeModal();
		}
	}

	useEffect(() => {
		const campaignScreen = screens.find((screen) => screen.type === 'campaign');

		if (campaignScreen) {
			setDataForm(campaignScreen.data as ScreenCampaignType);
		}
	}, []);

	return (
		<S.container>
			<S.box>
				<S.forms>
					<TitleForm title="Informações">
						<S.twoInputsRows>
							<SimpleInput
								label="Principal"
								initialValue={dataForm.firstTitleCampaign}
								getValue={(value: string) => {
									setDataForm((obj) => ({ ...obj, firstTitleCampaign: value }));
								}}
							/>

							<SimpleInput
								label="Secundário"
								initialValue={dataForm.secondTitleCampaign}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										secondTitleCampaign: value
									}));
								}}
							/>
						</S.twoInputsRows>
					</TitleForm>

					<TitleForm title="Primeira imagem">
						<S.manyInputsColumn>
							<InputImgBigger
								idImagem="mainImg"
								label="Imagem"
								getImage={(value: ImgSavedProps) => {
									setDataForm((obj) => ({
										...obj,
										mainImageCampaign: {
											...obj.mainImageCampaign,
											urlImage: value?.url || ''
										}
									}));
								}}
								initialImage={dataForm.mainImageCampaign.urlImage}
							/>
							<SimpleInput
								label="Link redirecionamento"
								initialValue={dataForm.mainImageCampaign.linkRedirect}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										mainImageCampaign: {
											...obj.mainImageCampaign,
											linkRedirect: value
										}
									}));
								}}
							/>
						</S.manyInputsColumn>
					</TitleForm>

					<TitleForm title="Carrossel de banners">
						<CreateImgWithRedirectAndLabel
							imgs={dataForm.carouselImagesCampaign}
							textBtn="Adicionar banner"
							getImgs={(imgs: ImageInCarrosselScreens[]) => {
								setDataForm((obj) => ({
									...obj,
									carouselImagesCampaign: imgs
								}));
							}}
						/>
					</TitleForm>

					<TitleForm title="Primeira lista de produtos">
						<SimpleInput
							label="Query"
							initialValue={dataForm.queryListProductsCampaign}
							getValue={(value: string) => {
								setDataForm((obj) => ({
									...obj,
									queryListProductsCampaign: value
								}));
							}}
						/>
					</TitleForm>

					<TitleForm title="Segunda imagem">
						<S.manyInputsColumn>
							<InputImgBigger
								idImagem="secondImg"
								label="Imagem"
								getImage={(value: ImgSavedProps) => {
									setDataForm((obj) => ({
										...obj,
										secondMainImageCampaign: {
											...obj.secondMainImageCampaign,
											urlImage: value?.url || ''
										}
									}));
								}}
								initialImage={dataForm.secondMainImageCampaign.urlImage}
							/>
							<SimpleInput
								label="Link redirecionamento"
								initialValue={dataForm.secondMainImageCampaign.linkRedirect}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										secondMainImageCampaign: {
											...obj.secondMainImageCampaign,
											linkRedirect: value
										}
									}));
								}}
							/>
						</S.manyInputsColumn>
					</TitleForm>

					<TitleForm title="Segunda lista de produtos">
						<SimpleInput
							label="Query"
							initialValue={dataForm.secondQueryListProductsCampaign}
							getValue={(value: string) => {
								setDataForm((obj) => ({
									...obj,
									secondQueryListProductsCampaign: value
								}));
							}}
						/>
					</TitleForm>

					<TitleForm title="Carrossel de marcas">
						<S.manyInputsColumn>
							<SimpleInput
								label="Título"
								initialValue={dataForm.brandsCarousel.title}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										brandsCarousel: { ...obj.brandsCarousel, title: value }
									}));
								}}
							/>
							<CreateImgWithRedirectAndLabel
								imgs={dataForm.brandsCarousel.brands}
								textBtn="Adicionar marca"
								getImgs={(imgs: ImageInCarrosselScreens[]) => {
									setDataForm((obj) => ({
										...obj,
										brandsCarousel: { ...obj.brandsCarousel, brands: imgs }
									}));
								}}
							/>
						</S.manyInputsColumn>
					</TitleForm>

					<TitleForm title="Terceira imagem">
						<S.manyInputsColumn>
							<InputImgBigger
								idImagem="thirdImg"
								label="Imagem"
								getImage={(value: ImgSavedProps) => {
									setDataForm((obj) => ({
										...obj,
										thirdMainImageCampaign: {
											...obj.thirdMainImageCampaign,
											urlImage: value?.url || ''
										}
									}));
								}}
								initialImage={dataForm.thirdMainImageCampaign.urlImage}
							/>
							<SimpleInput
								label="Link redirecionamento"
								initialValue={dataForm.thirdMainImageCampaign.linkRedirect}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										thirdMainImageCampaign: {
											...obj.thirdMainImageCampaign,
											linkRedirect: value
										}
									}));
								}}
							/>
						</S.manyInputsColumn>
					</TitleForm>

					<TitleForm title="Descrição">
						<S.manyInputsColumn>
							<SimpleInput
								label="Titulo"
								initialValue={dataForm.footer.title}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										footer: { ...dataForm.footer, title: value }
									}));
								}}
							/>

							<SimpleTextArea
								title="Descrição"
								rows={6}
								borderColor={color.interface.lightGray2}
								colorFont={color.interface.lightGray}
								labelColor={color.interface.lightGray}
								textArea={dataForm.footer.description}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										footer: { ...dataForm.footer, description: value }
									}));
								}}
							/>
						</S.manyInputsColumn>
					</TitleForm>
				</S.forms>
			</S.box>

			<S.containerBtns>
				<S.cancel
					data-testid="cancelBtn"
					onClick={() => {
						closeModal();
					}}
				>
					Cancelar
				</S.cancel>
				<S.save
					data-testid="saveBtn"
					onClick={() => {
						saveData();
					}}
				>
					Salvar
				</S.save>
			</S.containerBtns>
		</S.container>
	);
}
